module.exports = __webpack_public_path__ + "704b7f31c78d37b2b97f5840120f8e42.svg";